<section class="user-menu__section">
  <div class="user-menu__display clickable"
      fxLayout
      fxLayoutAlign="center center"
      fxFlexAlign="center"
      (click)="toggleUserMenu()">
    <div class="user-info">
      <span class="m__b--8">
        {{ displayName }}
      </span>
      <span>
        {{ displayRole }}
      </span>
    </div>
    <mat-icon>expand_more</mat-icon>
  </div>

  <div class="toggle-secondary-menu-user" *ngIf="displayUserMenu">
    <ul>
      <li class="item" *ngFor="let menuItem of menuItems">
        <a (click)="menuItem.action()">
          <i
            *ngIf="menuItem.icon"
            class="item-icon"
            [class]="menuItem.icon"
          ></i>
          <img *ngIf="menuItem.img" [src]="menuItem.img" />
          <span class="item-label m__l--8">{{ menuItem.label }}</span>
        </a>
      </li>
    </ul>
  </div>
</section>
